import axios from "axios"
import { del, get, patch, post, put } from "./api_helper"
import * as url from "./url_helper"

// Gets the logged in user data from local session
const getLoggedInUser = () => {
  const user = localStorage.getItem("user")
  if (user) return JSON.parse(user)
  return null
}

//is user is logged in
const isUserAuthenticated = () => {
  return getLoggedInUser() !== null
}

// Register Method
const postFakeRegister = data => {
  return axios
    .post(url.POST_FAKE_REGISTER, data)
    .then(response => {
      if (response.status >= 200 || response.status <= 299) return response.data
      throw response.data
    })
    .catch(err => {
      let message
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 404:
            message = "Sorry! the page you are looking for could not be found"
            break
          case 500:
            message =
              "Sorry! something went wrong, please contact our support team"
            break
          case 401:
            message = "Invalid credentials"
            break
          default:
            message = err[1]
            break
        }
      }
      throw message
    })
}

// Login Method
const postFakeLogin = data => post(url.POST_FAKE_LOGIN, data)

// postForgetPwd
const postFakeForgetPwd = data => post(url.POST_FAKE_PASSWORD_FORGET, data)

// Edit profile
const postJwtProfile = data => post(url.POST_EDIT_JWT_PROFILE, data)

const postFakeProfile = data => post(url.POST_EDIT_PROFILE, data)

// Register Method
const postJwtRegister = (url, data) => {
  return axios
    .post(url, data)
    .then(response => {
      if (response.status >= 200 || response.status <= 299) return response.data
      throw response.data
    })
    .catch(err => {
      var message
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 404:
            message = "Sorry! the page you are looking for could not be found"
            break
          case 500:
            message =
              "Sorry! something went wrong, please contact our support team"
            break
          case 401:
            message = "Invalid credentials"
            break
          default:
            message = err[1]
            break
        }
      }
      throw message
    })
}

// Login Method
const postJwtLogin = data => post(url.POST_FAKE_JWT_LOGIN, data)

// Login Method
const postJwtLogout = data => post(url.POST_JWT_LOGOUT, data)

// postForgetPwd
const postJwtForgetPwd = data => post(url.POST_FAKE_JWT_PASSWORD_FORGET, data)

// postSocialLogin
export const postSocialLogin = data => post(url.SOCIAL_LOGIN, data)

// get Products
export const getProducts = () => get(url.GET_PRODUCTS)

// get Product detail
export const getProductDetail = id =>
  get(`${url.GET_PRODUCTS_DETAIL}/${id}`, { params: { id } })

// get Events
export const getEvents = () => get(url.GET_EVENTS)

// add Events
export const addNewEvent = event => post(url.ADD_NEW_EVENT, event)

// update Event
export const updateEvent = event => put(url.UPDATE_EVENT, event)

// delete Event
export const deleteEvent = event =>
  del(url.DELETE_EVENT, { headers: { event } })

// get Categories
export const getCategories = () => get(url.GET_CATEGORIES)

// get chats
export const getChats = () => get(url.GET_CHATS)

// get groups
export const getGroups = () => get(url.GET_GROUPS)

// get Contacts
export const getContacts = () => get(url.GET_CONTACTS)

// get messages
export const getMessages = (roomId = "") =>
  get(`${url.GET_MESSAGES}/${roomId}`, { params: { roomId } })

// post messages
export const addMessage = message => post(url.ADD_MESSAGE, message)

// get orders
// export const getOrders = () => get(url.GET_ORDERS)

// add order
// export const addNewOrder = order => post(url.ADD_NEW_ORDER, order)

// update order
// export const updateOrder = order => put(url.UPDATE_ORDER, order)

// delete order
// export const deleteOrder = order =>
//   del(url.DELETE_ORDER, { headers: { order } })

// get cart data
export const getCartData = () => get(url.GET_CART_DATA)


// add CUSTOMER
export const addNewCustomer = customer => post(url.ADD_NEW_CUSTOMER, customer)

// update CUSTOMER
export const updateCustomer = customer => put(url.UPDATE_CUSTOMER, customer)

// delete CUSTOMER
export const deleteCustomer = customer =>
  del(url.DELETE_CUSTOMER, { headers: { customer } })

// get shops
export const getShops = () => get(url.GET_SHOPS)

// get wallet
export const getWallet = () => get(url.GET_WALLET)

// get crypto order
export const getCryptoOrder = () => get(url.GET_CRYPTO_ORDERS)

// get invoices
export const getInvoices = () => get(url.GET_INVOICES)

export const getInvoiceHistoryes = props => get(`${url.GET_GENERATED_INVOICE}/${props.paginate.size}/${props.paginate.page}/${props.params.id}`)
export const getInvoicesByCustomerId = props => get(`${url.GET_GENERATED_INVOICE}/${props.size}/${props.page}/${props.id}`)

export const addInvoiceHistory = props => post(`${url.POST_GENERATED_INVOICE}`,props)
// get invoice details
export const getInvoiceDetail = id =>
  get(`${url.GET_INVOICE_DETAIL}/${id}`, { params: { id } })

// get project
export const getProjects = () => get(url.GET_PROJECTS)

// get project details
export const getProjectsDetails = id =>
  get(`${url.GET_PROJECT_DETAIL}/${id}`, { params: { id } })

// get tasks
export const getTasks = () => get(url.GET_TASKS)

// get contacts
export const getUsers = () => get(url.GET_USERS)

// add user
export const addNewUser = user => post(url.ADD_NEW_USER, user)

// update user
export const updateUser = user => put(url.UPDATE_USER, user)

// delete user
export const deleteUser = user => del(url.DELETE_USER, { headers: { user } })

/** PROJECT */
// add user
export const addNewProject = project => post(url.ADD_NEW_PROJECT, project)

// update user
export const updateProject = project => put(url.UPDATE_PROJECT, project)

// delete user
export const deleteProject = project =>
  del(url.DELETE_PROJECT, { headers: { project } })

export const getUserProfile = () => get(url.GET_USER_PROFILE)

// get inboxmail
export const getInboxMails = () => get(url.GET_INBOX_MAILS)

// add inboxmail
export const addNewInboxMail = inboxmail =>
  post(url.ADD_NEW_INBOX_MAIL, inboxmail)

// delete inboxmail
export const deleteInboxMail = inboxmail =>
  del(url.DELETE_INBOX_MAIL, { headers: { inboxmail } })

// get starredmail
export const getStarredMails = () => get(url.GET_STARRED_MAILS)

// get importantmail
export const getImportantMails = () => get(url.GET_IMPORTANT_MAILS)

// get sent mail
export const getSentMails = () => get(url.GET_SENT_MAILS)

// get trash mail
export const getTrashMails = () => get(url.GET_TRASH_MAILS)

// get starredmail
export const getDraftMails = () => get(url.GET_DRAFT_MAILS)

// get dashboard charts data
export const getWeeklyData = () => get(url.GET_WEEKLY_DATA)
export const getYearlyData = () => get(url.GET_YEARLY_DATA)
export const getMonthlyData = () => get(url.GET_MONTHLY_DATA)
export const getInvoiceId = () => get(url.GET_INVOICE_ID)
export const saveGeneratedInvocie = (data) => post(url.SAVE_GENERATED_INVOICE,data);
export const getGeneratedInvoice = (data) => get(url.GET_GENERATED_INVOICE)

export const topSellingData = month =>
  get(`${url.TOP_SELLING_DATA}/${month}`, { params: { month } })

export const getEarningChartsData = month =>
  get(`${url.GET_EARNING_DATA}/${month}`, { params: { month } })

const getProductComents = () => get(url.GET_PRODUCT_COMMENTS)

const onLikeComment = (commentId, productId) => {
  return post(`${url.ON_LIKNE_COMMENT}/${productId}/${commentId}`, {
    params: { commentId, productId },
  })
}
const onLikeReply = (commentId, productId, replyId) => {
  return post(`${url.ON_LIKNE_COMMENT}/${productId}/${commentId}/${replyId}`, {
    params: { commentId, productId, replyId },
  })
}

const onAddReply = (commentId, productId, replyText) => {
  return post(`${url.ON_ADD_REPLY}/${productId}/${commentId}`, {
    params: { commentId, productId, replyText },
  })
}

const onAddComment = (productId, commentText) => {
  return post(`${url.ON_ADD_COMMENT}/${productId}`, {
    params: { productId, commentText },
  })
}

// get Products
// const getQuotes = props => {return get(url.GET_QUOTES)}
const getQuotes = (props) => post(`${url.GET_QUOTES}/${props.paginate.size}/${props.paginate.page}`, { params: props.params});

// update quotes
const updateQuotes = (props) => post(url.UPDATE_QUOTE_DETAIL,props);

// update quotes
const deleteQuotesURL = (props) => del(`${url.DELETE_QUOTE_DETAIL}/${props}`);


const getAuthUsersResponse = (props) => get(`${url.GET_CUSTOMER_DETAILS}/${props}`);

const getEmployeeResponse = (props) => post(`${url.GET_EMPLOYEES}/${props.prop.size}/${props.prop.page}`, {params: props.filter});

const updateAuthUser = (auth) => patch(`${url.UPDATE_CUSTOMER_FIELD}`, auth);

const updateAuthUserPassword = (auth) => patch(`${url.UPDATE_CUSTOMER_PASSWORD_FIELD}`, auth);

// get Product detail
const getQuoteDetail = id =>
  get(`${url.GET_QUOTE_DETAIL}/${id}`, { params: { id } })

  
// get Products
// const getQuotes = props => {return get(url.GET_QUOTES)}
const getVectors = (props) => post(`${url.GET_VECTORS}/${props.paginate.size}/${props.paginate.page}/${props.params.designation}`, { params: props.params});

// update quotes
const updateVectors = (props) => post(url.UPDATE_VECTOR_DETAIL,props);

// update quotes
const deleteVectorsURL = (props) => del(`${url.DELETE_VECTOR_DETAIL}/${props}`);

// get Product detail
const getVectorDetail = id =>
  get(`${url.GET_VECTOR_DETAIL}/${id}`, { params: { id } })


// get Product detail
const getOrderDetail = id =>
  get(`${url.GET_VECTOR_DETAIL}/${id}`, { params: { id } })


  // get Products
const getOrders = (props) => get(`${url.GET_ORDERS}/${props.paginate.size}/${props.paginate.page}`, { params: props.params});

// update quotes
const updateOrders = (props) => post(url.UPDATE_VECTOR_DETAIL,props);

// update quotes
const deleteOrdersURL = (props) => del(`${url.DELETE_VECTOR_DETAIL}/${props}`);

const convertToOrder = (props) => post(url.CONVERT_TO_ORDER,props);

// get Product detail
const getCustomerDetail = id =>
  get(`${url.GET_VECTOR_DETAIL}/${id}`, { params: { id } })


  // get Products
const getCustomers = (props) => get(`${url.GET_CUSTOMERS}/${props.paginate.size}/${props.paginate.page}`,  { params: props.params});

// update quotes
const updateCustomers = (props) => post(url.UPDATE_VECTOR_DETAIL,props);

const updateCustomersField = (props) => patch(url.UPDATE_CUSTOMER_FIELD, props) 

// update quotes
const deleteCustomersURL = (props) => del(`${url.DELETE_VECTOR_DETAIL}/${props}`);

  // get Products
const getReports = (props) => post(`${url.GET_REPORTS}/${props.paginate.size}/${props.paginate.page}`,  { params: props.params});

// get Product detail
const getEmployeeDetail = id =>
  get(`${url.GET_EMPLOYEE}/${id}`, { params: { id } })

  // get Products
const getEmployees = (props) => post(`${url.GET_EMPLOYEES}/${props.paginate.size}/${props.paginate.page}`,  { params: props.params});

// update quotes
const updateEmployees = (props) => post(url.UPDATE_EMPLOYEE,props);

// update quotes
const deleteEmployeesURL = (props) => del(`${url.DELETE_EMPLOYEE}/${props}`);

const paymentInvoice = (id) => get(`${url.PAYMENT_INVOICE}/${id}`);

// update quotes
const creatOrder = (props) => post(url.ADD_NEW_ORDER,props);

// update quotes
const updateOrder = (props) => put(`${url.UPDATE_ORDER}/${props._id}`,props);

const getCustomerDetails = (id) => get(`${url.GET_CUSTOMER_DETAILS}/${id}`) 


export {
  getLoggedInUser,
  isUserAuthenticated,
  postFakeRegister,
  postFakeLogin,
  postFakeProfile,
  postFakeForgetPwd,
  postJwtRegister,
  postJwtLogin,
  postJwtForgetPwd,
  postJwtProfile,
  getProductComents,
  onLikeComment,
  onLikeReply,
  onAddReply,
  onAddComment,
  getQuotes,
  getQuoteDetail,
  updateQuotes,
  deleteQuotesURL,
  getAuthUsersResponse,
  getVectorDetail,
  deleteVectorsURL,
  updateVectors,
  getVectors,
  deleteOrdersURL,
  updateOrders,
  updateOrder,
  getOrders,
  getOrderDetail,
  deleteCustomersURL,
  updateCustomers,
  getCustomers,
  getCustomerDetail,
  getReports,
  getEmployeeDetail,
  getEmployees,
  updateEmployees,
  deleteEmployeesURL,
  convertToOrder,
  paymentInvoice,
  postJwtLogout,
  updateCustomersField,
  creatOrder,
  getCustomerDetails,
  updateAuthUser,
updateAuthUserPassword,
getEmployeeResponse
}
